import {lazy} from "../../lib/lazy.js";
export const constraintRoutes = [
  {
    path: "/resource-constraints",
    component: lazy(() => import(/* webpackChunkName: "sorryRoutes" */ "../../views/resource-constraints/index.js"))
  }
];
